import { useEffect } from "react";
import { VeilighIcon } from "~/assets/logos";
import VeilighLogo from "~/assets/logos/veiligh_new_logo.png";
import { Icon } from "~/components/ui";
import { useSidebar } from "~/components/ui/sidebar";
import { DEFAULT_API_PAYLOAD } from "~/lib/constants";
import { fullname } from "~/lib/utils";
import { restApi } from "~/redux/restApi";
import { useSelector } from "~/redux/store";

const SidebarIcon = () => {
  const { state } = useSidebar();
  const { toggleSidebar } = useSidebar();
  const userRoles = useSelector(
    (state) => state.persistedReducer.auth.userTokenInfo?.roles,
  );
  const userId = useSelector((state) => state.persistedReducer.auth.userId);

  const [getProfile, { data }] = restApi.useLazyProfileQuery();
  const profile = data?.result;
  useEffect(() => {
    if (userId) {
      getProfile({
        ...DEFAULT_API_PAYLOAD,
        id: userId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <div className="">
      <div className="hidden sm:block">
        <div className="flex flex-col items-center justify-center py-10">
          {state === "collapsed" ? (
            <VeilighIcon />
          ) : (
            <span className="p-5 px-10 py-2 text-center">
              <img src={VeilighLogo} alt="Logo" />
            </span>
          )}
        </div>
        <div
          className={`${
            state === "collapsed" ? "hidden" : "block"
          } -mt-7 mb-10 px-9 text-center text-xs text-secondary-500`}
        >
          {userRoles?.map((role) => role.displayName).join(", ")}
        </div>
      </div>
      <div className="flex items-center justify-between p-5 sm:hidden">
        <div className="flex flex-col justify-start">
          <span className="text-2xl text-white">
            {fullname(profile?.firstName, profile?.lastName)}
          </span>
          <span className="text-xs text-secondary-500">
            {userRoles?.map((role) => role.displayName).join(", ")}
          </span>
        </div>
        <div>
          <Icon
            onClick={toggleSidebar}
            name="X"
            className="text-secondary-500 hover:cursor-pointer"
          />
        </div>
      </div>
    </div>
  );
};

export default SidebarIcon;
